<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chp" id="_idParaDest-5"><a id="_idTextAnchor004"></a></h1>
<p class="epi"><i class="italic">The mind of man is capable of anything—because everything is in it, all the past as well as all the future.</i></p>
<p class="right">—Joseph Conrad, <i class="italic">Heart of Darkness</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Headhunter-5.vue?585c3083